import { useEffect } from 'react';

const fonts = [
  { name: 'American Grotesk', file: 'test-american-grotesk-medium.woff2' },
  { name: 'American Grotesk Compressed', file: 'test-american-grotesk-compressed-medium.woff2' },
  { name: 'American Grotesk Condensed', file: 'test-american-grotesk-condensed-medium.woff2' },
  { name: 'Calibre', file: 'test-calibre-medium.woff2' },
  { name: 'Die Grotesk A', file: 'test-die-grotesk-a-medium.woff2' },
  { name: 'Die Grotesk B', file: 'test-die-grotesk-b-medium.woff2' },
  { name: 'Die Grotesk C', file: 'test-die-grotesk-c-medium.woff2' },
  { name: 'Die Grotesk D', file: 'test-die-grotesk-d-medium.woff2' },
  { name: 'Domaine Display', file: 'test-domaine-display-medium.woff2' },
  { name: 'Domaine Display Condensed', file: 'test-domaine-display-condensed-medium.woff2' },
  { name: 'Domaine Display Narrow', file: 'test-domaine-display-narrow-medium.woff2' },
  { name: 'Domaine Text', file: 'test-domaine-text-medium.woff2' },
  { name: 'Domaine Sans Display', file: 'test-domaine-sans-display-medium.woff2' },
  { name: 'Domaine Sans Fine', file: 'test-domaine-sans-fine-medium.woff2' },
  { name: 'Domaine Sans Text', file: 'test-domaine-sans-text-medium.woff2' },
  { name: 'Epicene Display', file: 'test-epicene-display-medium.woff2' },
  { name: 'Epicene Text', file: 'test-epicene-text-medium.woff2' },
  { name: 'Family', file: 'test-family-medium.woff2' },
  { name: 'Feijoa', file: 'test-feijoa-medium.woff2' },
  { name: 'Financier Display', file: 'test-financier-display-medium.woff2' },
  { name: 'Financier Text', file: 'test-financier-text-medium.woff2' },
  { name: 'Founders Grotesk', file: 'test-founders-grotesk-medium.woff2' },
  { name: 'Founders Grotesk Condensed', file: 'test-founders-grotesk-condensed-medium.woff2' },
  { name: 'Founders Grotesk Mono', file: 'test-founders-grotesk-mono-medium.woff2' },
  { name: 'Founders Grotesk Text', file: 'test-founders-grotesk-text-medium.woff2' },
  { name: 'Founders Grotesk X-Condensed', file: 'test-founders-grotesk-x-condensed-medium.woff2' },
  { name: 'Geograph', file: 'test-geograph-medium.woff2' },
  { name: 'Heldane Display', file: 'test-heldane-display-medium.woff2' },
  { name: 'Heldane Text', file: 'test-heldane-text-medium.woff2' },
  { name: 'Karbon', file: 'test-karbon-medium.woff2' },
  { name: 'Manuka', file: 'test-manuka-medium.woff2' },
  { name: 'Manuka Condensed', file: 'test-manuka-condensed-medium.woff2' },
  { name: 'Manuka Slab', file: 'test-manuka-slab-medium.woff2' },
  { name: 'Martina Plantijn', file: 'test-martina-plantijn-medium.woff2' },
  { name: 'Metric', file: 'test-metric-medium.woff2' },
  { name: 'National', file: 'test-national-medium.woff2' },
  { name: 'National 2', file: 'test-national-2-medium.woff2' },
  { name: 'National 2 Compressed', file: 'test-national-2-compressed-medium.woff2' },
  { name: 'National 2 Condensed', file: 'test-national-2-condensed-medium.woff2' },
  { name: 'National 2 Narrow', file: 'test-national-2-narrow-medium.woff2' },
  { name: 'Newzald', file: 'test-newzald-medium.woff2' },
  { name: 'Pitch', file: 'test-pitch-medium.woff2' },
  { name: 'Pitch Sans', file: 'test-pitch-sans-medium.woff2' },
  { name: 'Signifier', file: 'test-signifier-medium.woff2' },
  { name: 'The Future', file: 'test-the-future-medium.woff2' },
  { name: 'The Future Mono', file: 'test-the-future-mono-medium.woff2' },
  { name: 'Tiempos Fine', file: 'test-tiempos-fine-medium.woff2' },
  { name: 'Tiempos Headline', file: 'test-tiempos-headline-medium.woff2' },
  { name: 'Tiempos Text', file: 'test-tiempos-text-medium.woff2' },
  { name: 'Untitled Sans', file: 'test-untitled-sans-medium.woff2' },
  { name: 'Untitled Serif', file: 'test-untitled-serif-medium.woff2' },
];

export default function FontTest() {
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = fonts.map((f, i) => `
      @font-face {
        font-family: 'TestFont${i}';
        src: url('/test-fonts/${f.file}') format('woff2');
        font-weight: 500;
        font-display: swap;
      }
    `).join('\n');
    document.head.appendChild(style);
    return () => { document.head.removeChild(style); };
  }, []);

  return (
    <div className="min-h-screen bg-white p-12">
      <h1 className="text-2xl font-bold mb-8 text-gray-500">Font Test — "Falcon" in each typeface (Medium weight)</h1>
      <div className="grid grid-cols-1 gap-0">
        {fonts.map((f, i) => (
          <div key={f.name} className="flex items-baseline gap-8 py-4 border-b border-gray-100">
            <span className="text-xs text-gray-400 w-64 shrink-0">{f.name}</span>
            <span style={{ fontFamily: `'TestFont${i}', sans-serif`, letterSpacing: '-0.03em' }} className="text-5xl">
              Falcon
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
